import { useSearchParams } from "react-router-dom";
import useGetOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useGetOrderHistoryDetail";

const useOrderHistoryDetail = () => {
  const [searchParams] = useSearchParams();
  const orderSheetSetId = searchParams.get("order_sheet_set_id");
  const { data } = useGetOrderHistoryDetail(orderSheetSetId);

  return { data, orderSheetSetId };
};

export default useOrderHistoryDetail;
